var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_432_4385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.50883 2.13306L0.88129 9.7606L0.0167625 13.2813C-0.0316633 13.4785 0.0264695 13.6865 0.169997 13.83C0.313989 13.974 0.522184 14.0315 0.718704 13.9833L4.23946 13.1187L11.867 5.4912L8.50883 2.13306ZM1.11773 12.8823L1.41499 11.6718L2.32827 12.585L1.11773 12.8823Z",
    fill: "#181A20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.743 2.37393L11.6262 0.257086C11.2834 -0.0856953 10.7276 -0.0856953 10.3849 0.257086L9.54199 1.09996L12.9001 4.4581L13.743 3.61523C14.0858 3.27247 14.0858 2.71671 13.743 2.37393Z",
    fill: "#181A20"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_432_4385"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.8dadab40fb9c4142de1c855be69ffbe5.svg";
export { ForwardRef as ReactComponent };